import {getCookie, setCookie} from "../../JavaScript/utils/cookie";

export function initCookieConsent(root) {
    if (!root || root.CookieConsentInit) return;
    root.CookieConsentInit = true;

    const cookieName = "cookieconsent_status";
    const cookiePath = "/";
    const cookieExpiryDays = 365;

    const button = root.querySelector("[data-cookie-consent-action]");
    if (!button) return;
    
    const currentStatus = getCookie(cookieName);
    const validStatuses = new Set(["dismiss", "allow", "deny"]);

    if (validStatuses.has(currentStatus)) {
        root.hidden = true;
        return;
    }

    root.hidden = false;

    button.addEventListener("click", () => {
        const action = button.dataset.cookieConsentAction || "dismiss";

        if (!validStatuses.has(action)) return;

        setCookie(cookieName, action, cookieExpiryDays, cookiePath);
        root.hidden = true;
    });
}